// Exports the "axupimgs" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/axupimgs')
//   ES2015:
//     import 'tinymce/plugins/axupimgs'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./static/tinymce/axupimgs/index.js
// module id = Pslk
// module chunks = 1